import { enableProdMode, isDevMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Config
import { appConfig } from './app/config/app-config';
import { navigationConfig } from './app/nav/config/navigation.config';

if (environment.production) {
   enableProdMode();
}

// log in dev mode
appConfig.dev.mockingMode = environment.mocking;
if (isDevMode()) {
   console.log('DevEnv:', environment);
} else {
   appConfig.dev.debugMode = false;
   navigationConfig.debugMode = false;
   console.log('BuildEnv:', environment);
}

platformBrowserDynamic().bootstrapModule(AppModule)
   .catch(err => console.log(err));



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/main.ts